export const RANDA_MEMBER = 'RANDAMEMBER';
export const STANDARD = 'STANDARD';
export const THEONECLUB = 'THEONECLUB';